import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerMutationKeys,
  registersQueryKeys,
} from '@core/react-query/features/registers/registers'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateOrganisationRegister = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['createOrganisationRegister']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerMutationKeys.createOrganisationRegister,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(registersQueryKeys.registers._def)
    },
  })
}
